import {
  removeCampoCavalliMatrix,
  setCampiCavalliMatrix,
  setCampiCavalliTrioMatrix,
  setCampiMatriSelected,
} from 'features/ippica/ippicaSlice';
import {
  selectCampiMatrix,
  selectCodiceStatoCavallo,
  selectColonneByTipoScommessaFromSettings,
  selectTipoScommessaKey,
} from 'features/ippica/selectors';
import { useAppDispatch, useTypedSelector } from 'lib/centralStore';

import { Size } from 'features/ippica/types';
import { TRIO_IN_ORDINE_SIGLA_SISTEMA_KEY } from 'features/ippica/constants';
import dynamic from 'next/dynamic';
import { isStatoCavalloRetired } from 'features/ippica/functions';
import styles from './IppicaScommesseCampiList.module.scss';
import { validation } from 'features/ippica/actions';
import useWindowSize from 'hooks/useWindowSize';

export type IppicaScommesseCampiListProps = {
  values?: {
    id: string;
    value: string;
    checked?: boolean;
  }[];
  containerClassName?: string;
  size: Size;
  title?: string;
  indexCavallo: number;
  keyCavallo: string;
};

export const DynamicIppicaScommesseCampiList = dynamic(() =>
  import('features/ippica/components/ippicaScommesseCampiList').then((mod) => mod.IppicaScommesseCampiList)
);

export const IppicaScommesseCampiList = ({
  values,
  containerClassName,
  size,
  title,
  indexCavallo,
  keyCavallo,
}: IppicaScommesseCampiListProps) => {
  const { width } = useWindowSize();

  const campiMatrix = useTypedSelector(selectCampiMatrix);
  const colonneByTipoScommessaFromSettings = useTypedSelector(selectColonneByTipoScommessaFromSettings);
  // const [checkboxes, setCheckboxes] = useState<{ id: string; value: string; checked?: boolean }[]>(campiList);
  const dispatch = useAppDispatch();
  const tipoScommessaKey = useTypedSelector(selectTipoScommessaKey);
  const codiceStatoCavallo = useTypedSelector(selectCodiceStatoCavallo(keyCavallo));
  const isDisabledAvvenimento = isStatoCavalloRetired(codiceStatoCavallo);
  /*   const codiceProgramma = useTypedSelector(selectCodiceProgramma);
  const numeroAvvenimento = useTypedSelector(selectNumeroAvvenimento); */

  /*   const scommessaKey = new KeyManagerIppica({
    codiceProgramma: String(codiceProgramma),
    numeroAvvenimento: String(numeroAvvenimento),
    codiceTipoScommessa: tipoScommessaKey ?? '',
    infoAggiuntiva: '000000',
    codiceCavallo: '1',
  }); */

  // const campiList = [{ id: '', value: '', checked: '' }];

  const handleCheckboxChange = (key: string, indexSelected: number, checked: boolean) => {
    // TODO DE-COMMENT IN FUTURE
    // siglaSistemaKey && dispatch(handleSelectCampiMatrix({ siglaSistemaKey, key, indexSelected, checked }));
    if (tipoScommessaKey === TRIO_IN_ORDINE_SIGLA_SISTEMA_KEY) {
      dispatch(
        setCampiCavalliTrioMatrix({
          keyCavallo: key,
          indexSelected,
          checked: !checked,
          isDisable: !checked,
        })
      );
    } else {
      dispatch(setCampiMatriSelected({ keyCavallo: key, indexSelected, checked: !checked }));
    }
    if (!checked) {
      dispatch(
        setCampiCavalliMatrix({
          keyCavallo: key,
          indexSelected,
          checked: !checked,
          valueColumn: colonneByTipoScommessaFromSettings,
        })
      );
    } else {
      dispatch(
        removeCampoCavalliMatrix({ keyCavallo: key, indexSelected, valueColumn: colonneByTipoScommessaFromSettings })
      );
    }
    dispatch(validation({ isChecked: !checked, width }));
  };

  // TODO CHECK - For now, following change behaviour
  // const isDisabled = useMemo(() => {
  //   if (
  //     !!numeroCavalliMatrix?.length &&
  //     siglaSistemaKey &&
  //     tipoScommessaSettings &&
  //     siglaSistemaKey === TRIO_IN_ORDINE_SIGLA_SISTEMA_KEY
  //   ) {
  //     const isDisabled = tipoScommessaSettings[siglaSistemaKey].colonne.every((colonna, index) => {
  //       const from = tipoScommessaSettings[siglaSistemaKey].checkColonne[colonna].from;
  //       const to = tipoScommessaSettings[siglaSistemaKey].checkColonne[colonna].to;
  //       return numeroCavalliMatrix[index].length === from && numeroCavalliMatrix[index].length === to;
  //     });
  //     return isDisabled;
  //   }
  // }, [siglaSistemaKey, numeroCavalliMatrix]);

  return (
    <div
      className={`${styles.container} ${containerClassName ? containerClassName : ''} ${
        styles[(size as keyof typeof Size).toLowerCase()]
      }`}
    >
      {title && <span className={styles.title}>{title}</span>}

      <div className={styles.checkboxesContainer}>
        {campiMatrix &&
          !!campiMatrix[keyCavallo]?.length &&
          campiMatrix[keyCavallo].map((checkbox, index) => {
            const { id, value } = checkbox;
            return (
              <div
                key={id + '_' + index}
                className={`${styles.checkbox} 
                ${checkbox?.checked ? styles.checked : ''}
                ${checkbox.isDisable || isDisabledAvvenimento ? styles.isDisabled : ''}`}
              >
                <input
                  type="checkbox"
                  id={String(id)}
                  name={value}
                  disabled={checkbox.isDisable || isDisabledAvvenimento}
                  className={styles.input}
                  onChange={() => handleCheckboxChange(keyCavallo, index, checkbox.checked)}
                />
                <label htmlFor={value} className={styles.label}>
                  {!isDisabledAvvenimento ? value : '-'}
                </label>
              </div>
            );
          })}
      </div>
    </div>
  );
};
